export default "__VITE_ASSET__B9cPR6u4__"